// i18n-setup.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import en from '@/assets/langs/en.json'
// import store from '@/store'
// import _ from 'lodash'
Vue.use(VueI18n)
const i18n = new VueI18n({
  fallbackLocale: 'en',
  silentTranslationWarn: true
})

export default i18n

const loadedLanguages = [] // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }
  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }
  lang === 'en' && i18n.setLocaleMessage(lang, en)
  return Promise.resolve(setI18nLanguage(lang))
}
